import React from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { faUserGroup } from '@fortawesome/free-solid-svg-icons';

import NeritoHome from '../../assets/images/NeritoHome2.png';
import PrimaryButton from '../../components/common/primaryButton';

import theme from '../../styles/theme.js';
import '../../App.css';

const OurApp = () => {
  const classes = useStyles();

  return (
    <div className={classes.ourAppContainer} >
      <div className={classes.halfContainer}>
        <div>
          <Typography className={classes.blackTitle}> Explora lo que </Typography>
          <Typography className={classes.greenTitle}>Nerito ofrece</Typography>
        </div>
        <img src={NeritoHome} alt='nerito-home' className={classes.image} />
      </div>

      <div className={classes.halfLeftContainer}>
        <div className={classes.textContainer}>
          <ol>
            <li className = {classes.list}>
              <span className={classes.listTitle}>Todo desde el celular</span>
              <br />
              <p className={classes.listText}>
                No necesitas acudir a una sucursal para abrir cuenta: <span className = {classes.listSubtitle}> la activación es inmediata y 100% digital.</span>
              </p>
            </li>
            <li className = {classes.list}>
              <span className={classes.listTitle}>Resguarda el valor de tu dinero</span>
              <br />
              <p className={classes.listText}>
                Tu dinero puede <span className = {classes.listSubtitle}> permanecer en USD. </span>
              </p>
            </li>
            <li className = {classes.list}>
              <span className={classes.listTitle}>Pagos y servicios al instante en México</span>
              <br />
              <p className={classes.listText}>
                Desde Nerito puedes<span className = {classes.listSubtitle}>  pagar servicios </span> a tus familiares en México.
              </p>
            </li>
            <li className = {classes.list}>
              <span className={classes.listTitle}>Envíos de dinero fáciles y seguros</span>
              <br />
              <p className={classes.listText}>
                Olvídate de las remesadoras tradicionales. <span className = {classes.listSubtitle}> Envía dinero al instante </span> a cualquier cuenta bancaria en México.
              </p>
            </li>
            <li className = {classes.list}>
              <span className={classes.listTitle}>Transferencias SPEI</span>
              <br />
              <p className={classes.listText}>
                Desde tu celular puedes <span className = {classes.listSubtitle}>enviar dinero vía SPEI.</span>
              </p>
            </li>
            <li className = {classes.list}>
              <span className={classes.listTitle}>Menos costos, menos riesgos</span>
              <br />
              <p className={classes.listText}>
              Se eliminan intermediarios, es la forma <span className = {classes.listSubtitle}>más económica</span> de enviar dinero y <span className = {classes.listSubtitle}>reducir riesgos de </span> envíos por remeseadoras tradicionales.
              </p>
            </li>
          </ol>
        </div>
      </div>

    </div>
  )
}

export default OurApp;

const useStyles = makeStyles({
  ourAppContainer: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    padding: 50,
    [theme.breakpoints.down('xs')]: {
      alignItems: 'center',
      padding: 30,
      flexDirection: 'column',
      justifyContent: 'center',
    },
  },
  greenTitle: {
    fontFamily: 'Montserrat',
    fontWeight: '700',
    fontSize: 60,
    color: theme.palette.green.main,
    padding: 0,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      fontSize: 40
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 35,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 28,
    },
  },
  thinTitle: {
    fontFamily: 'Lato',
    fontWeight: '300',
    fontSize: 24,
    [theme.breakpoints.down('md')]: {
      fontSize: 20
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 20,
      textAlign: 'center',
    },
  },
  blackTitle: {
    fontFamily: 'Montserrat',
    fontWeight: '700',
    fontSize: 60,
    color: theme.palette.black.main,
    padding: 0,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      fontSize: 40
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 35,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 28,
    },
  },
  halfContainer: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      margin: 0,
      alignItems: 'center',
      width: '100%', 
    },
  },
  halfLeftContainer: {
    width: '50%',
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginLeft: 100,
    [theme.breakpoints.down('md')]: {
      margin: 0,
      alignItems: 'center',
      width: '100%', 
    },
  },
  textContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 30,
    // width: '80%',
    height: '100%',
    padding: 50,
    textAlign: 'justify',
    justifyContent: 'center',
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      gap: 20,
      padding: 30,
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
      padding: 10,
      gap: 10,
    },
  },
  image: {
    [theme.breakpoints.down('md')]: {
      alignItems: 'center',
      // padding: 30,
      width: '100%'
      // flexDirection: 'column'
    },
    [theme.breakpoints.down('xs')]: {
      padding: 10,
    },
  },
  list: {
    lineHeight: 2,
    fontSize: 20,
    textAlign: 'justify',
    '&::marker': {
      fontWeight: '700',
      fontFamily: 'Montserrat',
      color: theme.palette.green.main
    }
  },
  listTitle: {
    fontFamily: 'Montserrat',
    fontWeight: '700',
    fontSize: 25,
    color: theme.palette.green.main,
    padding: 0,
    [theme.breakpoints.down('md')]: {
      textAlign: 'center',
      fontSize: 20
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: 20,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 18,
    },
  },
  listText: {
    fontFamily: 'Montserrat',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  listSubtitle: {
    fontFamily: 'Montserrat',
    fontWeight: '700',
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  }
});